export type SelectOptionsResponse = Array<{
  descricao: string
  valor: string
}>

export type SelectOptionsFormated = { id: string; options: Array<{ text: string; value: string }> }

export enum SelectUriEnum {
  como_encontrou = 'plataforma-origem',
  motivo_parceria = 'motivos-parceria',
  porte_empresa = 'tamanho-empresa',
  trabalha_com_garantia_imovel = 'trabalho-garantia',
  ramo_atuacao = 'ramos-atucao',
  regional = 'regioes-atuacao',
  produtos_cashme = 'produtos-escolha'
}
